import React from 'react';

interface ErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ isOpen, onClose, message }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-auto bg-black bg-opacity-40 flex" data-testid="error-modal-overlay">
      <div className="relative p-6 bg-white w-11/12 max-w-md m-auto flex-col flex rounded-lg" data-testid="error-modal-container">
        <div className="flex items-center justify-center mb-4" data-testid="error-modal-icon-container">
          <svg 
            className="w-16 h-16 text-red-500" 
            fill="currentColor" 
            viewBox="0 0 20 20" 
            xmlns="http://www.w3.org/2000/svg"
            data-testid="error-modal-icon"
          >
            <path 
              fillRule="evenodd" 
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" 
              clipRule="evenodd" 
            />
          </svg>
        </div>
        <div className="text-center mb-4" data-testid="error-modal-content">
          <h3 className="text-xl font-semibold text-gray-900 mb-2" data-testid="error-modal-title">Error</h3>
          <p className="text-gray-600" data-testid="error-modal-message">{message}</p>
        </div>
        <button
          className="px-4 py-2 bg-red-500 text-white text-base font-medium rounded-md shadow-sm hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-300"
          onClick={onClose}
          data-testid="error-modal-close-button"
        >
          Cerrar
        </button>
      </div>
    </div>
  );
};

export default ErrorModal;